import { message } from "antd";
import { makeAutoObservable } from "mobx";
import ITask from "../../models/task";
import { TaskService } from "../../services/task-service";

export default class TaskCloneStore {

    data: ITask;
    taskId: number | null;
    isClone: boolean;
    taskService: TaskService;

    constructor(data: ITask, taskId: number | null, taskService: TaskService) {
        this.data = data;
        this.isClone = false;
        this.taskId = taskId;
        this.taskService = taskService;
        makeAutoObservable(this);
    }

    toggleClone(checked: boolean): void {

        if (this.taskId) {

            if (checked) {
                this.taskService.markAsClone(this.taskId, this.data.id, (_) => {
                    message.success("Задача помечена как клон");
                    this.isClone = true;
                });
            } else {
                this.taskService.unmarkAsClone(this.taskId, (_) => {
                    message.success("Пометка клона снята");
                    this.isClone = false;
                });
            }
        }
    }
}